// src/services/metrics.ts
import { API_BASE_URL } from "@/services";
import type { MetricInfo } from "@/types/metrics";

export async function fetchMetricsCatalog(signal?: AbortSignal): Promise<MetricInfo[]> {
  const url = `${API_BASE_URL}/metrics`;
  const init: RequestInit = signal ? { signal } : {};
  const res = await fetch(url, init);
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  return res.json();
}


